
















import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import LoadingIndicator from "@/view/shared-components/LoadingIndicator.vue";

@Component({
    components: {LoadingIndicator}
})
export default class SubmitTicketButtonGroupMobile extends Vue {
    @Prop({required: false}) allowSubmit!:boolean;
    @Prop({required: false}) allowReset!:boolean;
    @Prop({required: false}) submitButtonText!:string;
    @Prop({required: false}) hasTabs!:boolean;
    @Prop({required: false}) submitButtonBusy!:boolean;
    private submitVariant: string = 'outline-secondary';
    private resetVariant: string = 'outline-secondary';

    @Watch('allowSubmit')
    onSubmitChange(value: boolean, oldValue:boolean){
        if (value) {
            this.submitVariant = 'secondary'
        } else {
            this.submitVariant = 'outline-secondary'
        }
    }
    @Watch('allowReset')
    onResetChange(value: boolean, oldValue:boolean){
        if (value) {
            this.resetVariant = 'warning'
        } else {
            this.resetVariant = 'outline-secondary'
        }
    }
}
